export default __webpack_public_path__ + "static/media/three-tips.9250406b.svg";